
import 'pages/products/options/options-groups-list.tag'
import 'pages/products/options/options-list.tag'
riot.tag2('options', '  <ul class="nav nav-tabs m-b-2" if="{!edit}">\n    <li class="active"><a data-toggle="tab" href="#options-list">Опции</a></li>\n    <li><a data-toggle="tab" href="#options-groups">Группы</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="options-list">\n      <options-list></options-list>\n    </div>\n    <div class="tab-pane fade" id="options-groups">\n      <options-groups-list></options-groups-list>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create();
self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/options/options.tag